import React from 'react';

// Mobile-first page wrapper: full-bleed on phones, centered max-w-md on desktop.
export function MobileShell({ children, className = '' }) {
  return (
    <div className="min-h-screen w-full bg-white">
      <div className={`mx-auto min-h-screen w-full max-w-md overflow-y-auto ${className}`}>
        {children}
      </div>
    </div>
  );
}
